// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* 
   * Color Palette - Slate (Neutrals)
   * Tailored for high accessibility and modern aesthetic
   */
  --color-slate-50: #f8fafc;
  --color-slate-100: #f1f5f9;
  --color-slate-200: #e2e8f0;
  --color-slate-300: #cbd5e1;
  --color-slate-400: #94a3b8;
  --color-slate-500: #64748b;
  --color-slate-600: #475569;
  --color-slate-700: #334155;
  --color-slate-800: #1e293b;
  --color-slate-900: #0f172a;
  --color-slate-950: #020617;

  /* 
   * Color Palette - Indigo (Primary)
   * Vibrant and accessible
   */
  --color-indigo-50: #eef2ff;
  --color-indigo-100: #e0e7ff;
  --color-indigo-200: #c7d2fe;
  --color-indigo-300: #a5b4fc;
  --color-indigo-400: #818cf8;
  --color-indigo-500: #6366f1;
  --color-indigo-600: #4f46e5;
  --color-indigo-700: #4338ca;
  --color-indigo-800: #3730a3;
  --color-indigo-900: #312e81;
  --color-indigo-950: #1e1b4b;

  /* Semantic Colors - Light Mode (Default) */
  --bg-app: var(--color-slate-50);
  --bg-base: var(--color-slate-50);
  --bg-surface: #ffffff;
  --bg-surface-hover: var(--color-slate-50);
  --bg-surface-active: var(--color-slate-100);

  --text-primary: var(--color-slate-900);
  --text-secondary: var(--color-slate-600);
  --text-tertiary: var(--color-slate-500);
  --text-inverse: #ffffff;

  --border-default: var(--color-slate-200);
  --border-hover: var(--color-slate-300);

  --primary-default: var(--color-indigo-600);
  --primary-hover: var(--color-indigo-700);
  --primary-active: var(--color-indigo-800);
  --primary-subtle: var(--color-indigo-50);
  --primary-border: var(--color-indigo-200);

  /*
   * Status Colors - Success (Green)
   */
  --color-green-50: #f0fdf4;
  --color-green-100: #dcfce7;
  --color-green-200: #bbf7d0;
  --color-green-300: #86efac;
  --color-green-400: #4ade80;
  --color-green-500: #22c55e;
  --color-green-600: #16a34a;
  --color-green-700: #15803d;
  --color-green-800: #166534;
  --color-green-900: #14532d;

  /*
   * Status Colors - Warning (Amber/Yellow)
   */
  --color-amber-50: #fffbeb;
  --color-amber-100: #fef3c7;
  --color-amber-200: #fde68a;
  --color-amber-500: #f59e0b;
  --color-amber-600: #d97706;
  --color-amber-700: #b45309;
  --color-amber-800: #92400e;
  --color-amber-900: #78350f;

  /*
   * Status Colors - Error (Red)
   */
  --color-red-50: #fef2f2;
  --color-red-100: #fee2e2;
  --color-red-200: #fecaca;
  --color-red-300: #fca5a5;
  --color-red-500: #ef4444;
  --color-red-600: #dc2626;
  --color-red-700: #b91c1c;
  --color-red-800: #991b1b;
  --color-red-900: #7f1d1d;

  /*
   * Status Colors - Info (Blue)
   */
  --color-blue-50: #eff6ff;
  --color-blue-100: #dbeafe;
  --color-blue-200: #bfdbfe;
  --color-blue-300: #93c5fd;
  --color-blue-500: #3b82f6;
  --color-blue-600: #2563eb;
  --color-blue-700: #1d4ed8;
  --color-blue-800: #1e40af;
  --color-blue-900: #1e3a8a;

  /*
   * Status Colors - Orange (for serious/warning variants)
   */
  --color-orange-100: #ffedd5;
  --color-orange-200: #fed7aa;
  --color-orange-500: #f97316;
  --color-orange-600: #ea580c;
  --color-orange-700: #c2410c;
  --color-orange-800: #9a3412;

  /*
   * Color Palette - Purple (for PATCH/special actions)
   */
  --color-purple-100: #f3e8ff;
  --color-purple-200: #e9d5ff;
  --color-purple-300: #d8b4fe;
  --color-purple-500: #a855f7;
  --color-purple-600: #9333ea;
  --color-purple-700: #7e22ce;
  --color-purple-800: #6b21a8;
  --color-purple-900: #581c87;

  /* Semantic Status Colors - Light Mode */
  --status-success-bg: var(--color-green-100);
  --status-success-text: var(--color-green-800);
  --status-success-solid: var(--color-green-500);

  --status-warning-bg: var(--color-amber-200);
  --status-warning-text: var(--color-amber-800);
  --status-warning-solid: var(--color-amber-500);

  --status-error-bg: var(--color-red-200);
  --status-error-text: var(--color-red-800);
  --status-error-solid: var(--color-red-500);

  --status-info-bg: var(--color-indigo-100);
  --status-info-text: var(--color-indigo-800);
  --status-info-solid: var(--color-indigo-500);

  --status-serious-bg: var(--color-orange-200);
  --status-serious-text: var(--color-orange-800);

  /* HTTP Method Colors - semantic for API display */
  --http-get: var(--color-green-700);
  --http-post: var(--color-blue-700);
  --http-put: var(--color-orange-800);
  --http-patch: var(--color-purple-700);
  --http-delete: var(--color-red-800);

  /* Visualization Status Colors - for heartbeat/status indicators */
  --viz-healthy: #00ff88;
  --viz-healthy-core: #00cc6a;
  --viz-degraded: #ffe66d;
  --viz-degraded-core: #ccb800;
  --viz-error: #ff6b6b;
  --viz-error-core: #cc4444;
  --viz-unknown: var(--color-slate-500);
  --viz-unknown-core: var(--color-slate-600);

  /* Spacing */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-6: 1.5rem;
  --space-8: 2rem;
  --space-12: 3rem;
  --space-16: 4rem;

  /* Radius */
  --radius-sm: 0.25rem;
  --radius-md: 0.375rem;
  --radius-lg: 0.5rem;
  --radius-full: 9999px;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg:
    0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);

  /* Transitions */
  --transition-base: all 0.2s ease-in-out;

  /* Layout */
  --content-width: 1100px;
}

/* Dark Mode Overrides */
[data-theme='dark'] {
  --bg-app: var(--color-slate-950);
  --bg-base: var(--color-slate-950);
  --bg-surface: var(--color-slate-900);
  --bg-surface-hover: var(--color-slate-800);
  --bg-surface-active: var(--color-slate-700);

  --text-primary: var(--color-slate-50);
  --text-secondary: var(--color-slate-300);
  --text-tertiary: var(--color-slate-400);
  --text-inverse: var(--color-slate-900);

  --border-default: var(--color-slate-800);
  --border-hover: var(--color-slate-700);

  --primary-default: var(--color-indigo-400);
  --primary-hover: var(--color-indigo-300);
  --primary-active: var(--color-indigo-200);
  --primary-subtle: var(--color-indigo-950);
  --primary-border: var(--color-indigo-800);

  /* Status Colors - Dark Mode */
  --status-success-bg: var(--color-green-900);
  --status-success-text: var(--color-green-200);
  --status-success-solid: var(--color-green-500);

  --status-warning-bg: var(--color-amber-900);
  --status-warning-text: var(--color-amber-200);
  --status-warning-solid: var(--color-amber-500);

  --status-error-bg: var(--color-red-900);
  --status-error-text: var(--color-red-200);
  --status-error-solid: var(--color-red-500);

  --status-info-bg: var(--color-indigo-950);
  --status-info-text: var(--color-indigo-200);
  --status-info-solid: var(--color-indigo-400);

  --status-serious-bg: var(--color-orange-800);
  --status-serious-text: var(--color-orange-100);

  /* HTTP Method Colors - Dark Mode (brighter for visibility on dark backgrounds) */
  --http-get: var(--color-green-300);
  --http-post: var(--color-blue-300);
  --http-put: var(--color-orange-200);
  --http-patch: var(--color-purple-300);
  --http-delete: var(--color-red-300);

  /* Visualization Status - Dark Mode (same vivid colors work well on dark) */
  --viz-unknown: var(--color-slate-400);
  --viz-unknown-core: var(--color-slate-500);
}
`, "",{"version":3,"sources":["webpack://./src/ui/shared/styles/tokens.css"],"names":[],"mappings":"AAAA;EACE;;;IAGE;EACF,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B;;;IAGE;EACF,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2CAA2C;EAC3C,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;EACrB,yCAAyC;EACzC,2CAA2C;;EAE3C,sCAAsC;EACtC,wCAAwC;EACxC,uCAAuC;EACvC,uBAAuB;;EAEvB,wCAAwC;EACxC,sCAAsC;;EAEtC,0CAA0C;EAC1C,wCAAwC;EACxC,yCAAyC;EACzC,wCAAwC;EACxC,yCAAyC;;EAEzC;;IAEE;EACF,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B;;IAEE;EACF,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B;;IAEE;EACF,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB;;IAEE;EACF,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB;;IAEE;EACF,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B;;IAEE;EACF,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,wCAAwC;EACxC,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;;EAE9C,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;;EAE9C,uCAAuC;EACvC,yCAAyC;EACzC,0CAA0C;;EAE1C,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;;EAE5C,4CAA4C;EAC5C,8CAA8C;;EAE9C,kDAAkD;EAClD,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;;EAEnC,kEAAkE;EAClE,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;EACzB,qCAAqC;EACrC,0CAA0C;;EAE1C,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;;EAErB,YAAY;EACZ,0CAA0C;EAC1C,6EAA6E;EAC7E;sEACoE;;EAEpE,gBAAgB;EAChB,uCAAuC;;EAEvC,WAAW;EACX,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,0CAA0C;EAC1C,2CAA2C;;EAE3C,qCAAqC;EACrC,wCAAwC;EACxC,uCAAuC;EACvC,sCAAsC;;EAEtC,wCAAwC;EACxC,sCAAsC;;EAEtC,0CAA0C;EAC1C,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;;EAEzC,8BAA8B;EAC9B,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;;EAE9C,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;;EAE9C,uCAAuC;EACvC,yCAAyC;EACzC,0CAA0C;;EAE1C,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;;EAE5C,4CAA4C;EAC5C,8CAA8C;;EAE9C,iFAAiF;EACjF,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;;EAEnC,2EAA2E;EAC3E,qCAAqC;EACrC,0CAA0C;AAC5C","sourcesContent":[":root {\n  /* \n   * Color Palette - Slate (Neutrals)\n   * Tailored for high accessibility and modern aesthetic\n   */\n  --color-slate-50: #f8fafc;\n  --color-slate-100: #f1f5f9;\n  --color-slate-200: #e2e8f0;\n  --color-slate-300: #cbd5e1;\n  --color-slate-400: #94a3b8;\n  --color-slate-500: #64748b;\n  --color-slate-600: #475569;\n  --color-slate-700: #334155;\n  --color-slate-800: #1e293b;\n  --color-slate-900: #0f172a;\n  --color-slate-950: #020617;\n\n  /* \n   * Color Palette - Indigo (Primary)\n   * Vibrant and accessible\n   */\n  --color-indigo-50: #eef2ff;\n  --color-indigo-100: #e0e7ff;\n  --color-indigo-200: #c7d2fe;\n  --color-indigo-300: #a5b4fc;\n  --color-indigo-400: #818cf8;\n  --color-indigo-500: #6366f1;\n  --color-indigo-600: #4f46e5;\n  --color-indigo-700: #4338ca;\n  --color-indigo-800: #3730a3;\n  --color-indigo-900: #312e81;\n  --color-indigo-950: #1e1b4b;\n\n  /* Semantic Colors - Light Mode (Default) */\n  --bg-app: var(--color-slate-50);\n  --bg-base: var(--color-slate-50);\n  --bg-surface: #ffffff;\n  --bg-surface-hover: var(--color-slate-50);\n  --bg-surface-active: var(--color-slate-100);\n\n  --text-primary: var(--color-slate-900);\n  --text-secondary: var(--color-slate-600);\n  --text-tertiary: var(--color-slate-500);\n  --text-inverse: #ffffff;\n\n  --border-default: var(--color-slate-200);\n  --border-hover: var(--color-slate-300);\n\n  --primary-default: var(--color-indigo-600);\n  --primary-hover: var(--color-indigo-700);\n  --primary-active: var(--color-indigo-800);\n  --primary-subtle: var(--color-indigo-50);\n  --primary-border: var(--color-indigo-200);\n\n  /*\n   * Status Colors - Success (Green)\n   */\n  --color-green-50: #f0fdf4;\n  --color-green-100: #dcfce7;\n  --color-green-200: #bbf7d0;\n  --color-green-300: #86efac;\n  --color-green-400: #4ade80;\n  --color-green-500: #22c55e;\n  --color-green-600: #16a34a;\n  --color-green-700: #15803d;\n  --color-green-800: #166534;\n  --color-green-900: #14532d;\n\n  /*\n   * Status Colors - Warning (Amber/Yellow)\n   */\n  --color-amber-50: #fffbeb;\n  --color-amber-100: #fef3c7;\n  --color-amber-200: #fde68a;\n  --color-amber-500: #f59e0b;\n  --color-amber-600: #d97706;\n  --color-amber-700: #b45309;\n  --color-amber-800: #92400e;\n  --color-amber-900: #78350f;\n\n  /*\n   * Status Colors - Error (Red)\n   */\n  --color-red-50: #fef2f2;\n  --color-red-100: #fee2e2;\n  --color-red-200: #fecaca;\n  --color-red-300: #fca5a5;\n  --color-red-500: #ef4444;\n  --color-red-600: #dc2626;\n  --color-red-700: #b91c1c;\n  --color-red-800: #991b1b;\n  --color-red-900: #7f1d1d;\n\n  /*\n   * Status Colors - Info (Blue)\n   */\n  --color-blue-50: #eff6ff;\n  --color-blue-100: #dbeafe;\n  --color-blue-200: #bfdbfe;\n  --color-blue-300: #93c5fd;\n  --color-blue-500: #3b82f6;\n  --color-blue-600: #2563eb;\n  --color-blue-700: #1d4ed8;\n  --color-blue-800: #1e40af;\n  --color-blue-900: #1e3a8a;\n\n  /*\n   * Status Colors - Orange (for serious/warning variants)\n   */\n  --color-orange-100: #ffedd5;\n  --color-orange-200: #fed7aa;\n  --color-orange-500: #f97316;\n  --color-orange-600: #ea580c;\n  --color-orange-700: #c2410c;\n  --color-orange-800: #9a3412;\n\n  /*\n   * Color Palette - Purple (for PATCH/special actions)\n   */\n  --color-purple-100: #f3e8ff;\n  --color-purple-200: #e9d5ff;\n  --color-purple-300: #d8b4fe;\n  --color-purple-500: #a855f7;\n  --color-purple-600: #9333ea;\n  --color-purple-700: #7e22ce;\n  --color-purple-800: #6b21a8;\n  --color-purple-900: #581c87;\n\n  /* Semantic Status Colors - Light Mode */\n  --status-success-bg: var(--color-green-100);\n  --status-success-text: var(--color-green-800);\n  --status-success-solid: var(--color-green-500);\n\n  --status-warning-bg: var(--color-amber-200);\n  --status-warning-text: var(--color-amber-800);\n  --status-warning-solid: var(--color-amber-500);\n\n  --status-error-bg: var(--color-red-200);\n  --status-error-text: var(--color-red-800);\n  --status-error-solid: var(--color-red-500);\n\n  --status-info-bg: var(--color-indigo-100);\n  --status-info-text: var(--color-indigo-800);\n  --status-info-solid: var(--color-indigo-500);\n\n  --status-serious-bg: var(--color-orange-200);\n  --status-serious-text: var(--color-orange-800);\n\n  /* HTTP Method Colors - semantic for API display */\n  --http-get: var(--color-green-700);\n  --http-post: var(--color-blue-700);\n  --http-put: var(--color-orange-800);\n  --http-patch: var(--color-purple-700);\n  --http-delete: var(--color-red-800);\n\n  /* Visualization Status Colors - for heartbeat/status indicators */\n  --viz-healthy: #00ff88;\n  --viz-healthy-core: #00cc6a;\n  --viz-degraded: #ffe66d;\n  --viz-degraded-core: #ccb800;\n  --viz-error: #ff6b6b;\n  --viz-error-core: #cc4444;\n  --viz-unknown: var(--color-slate-500);\n  --viz-unknown-core: var(--color-slate-600);\n\n  /* Spacing */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n  --space-12: 3rem;\n  --space-16: 4rem;\n\n  /* Radius */\n  --radius-sm: 0.25rem;\n  --radius-md: 0.375rem;\n  --radius-lg: 0.5rem;\n  --radius-full: 9999px;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg:\n    0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n\n  /* Transitions */\n  --transition-base: all 0.2s ease-in-out;\n\n  /* Layout */\n  --content-width: 1100px;\n}\n\n/* Dark Mode Overrides */\n[data-theme='dark'] {\n  --bg-app: var(--color-slate-950);\n  --bg-base: var(--color-slate-950);\n  --bg-surface: var(--color-slate-900);\n  --bg-surface-hover: var(--color-slate-800);\n  --bg-surface-active: var(--color-slate-700);\n\n  --text-primary: var(--color-slate-50);\n  --text-secondary: var(--color-slate-300);\n  --text-tertiary: var(--color-slate-400);\n  --text-inverse: var(--color-slate-900);\n\n  --border-default: var(--color-slate-800);\n  --border-hover: var(--color-slate-700);\n\n  --primary-default: var(--color-indigo-400);\n  --primary-hover: var(--color-indigo-300);\n  --primary-active: var(--color-indigo-200);\n  --primary-subtle: var(--color-indigo-950);\n  --primary-border: var(--color-indigo-800);\n\n  /* Status Colors - Dark Mode */\n  --status-success-bg: var(--color-green-900);\n  --status-success-text: var(--color-green-200);\n  --status-success-solid: var(--color-green-500);\n\n  --status-warning-bg: var(--color-amber-900);\n  --status-warning-text: var(--color-amber-200);\n  --status-warning-solid: var(--color-amber-500);\n\n  --status-error-bg: var(--color-red-900);\n  --status-error-text: var(--color-red-200);\n  --status-error-solid: var(--color-red-500);\n\n  --status-info-bg: var(--color-indigo-950);\n  --status-info-text: var(--color-indigo-200);\n  --status-info-solid: var(--color-indigo-400);\n\n  --status-serious-bg: var(--color-orange-800);\n  --status-serious-text: var(--color-orange-100);\n\n  /* HTTP Method Colors - Dark Mode (brighter for visibility on dark backgrounds) */\n  --http-get: var(--color-green-300);\n  --http-post: var(--color-blue-300);\n  --http-put: var(--color-orange-200);\n  --http-patch: var(--color-purple-300);\n  --http-delete: var(--color-red-300);\n\n  /* Visualization Status - Dark Mode (same vivid colors work well on dark) */\n  --viz-unknown: var(--color-slate-400);\n  --viz-unknown-core: var(--color-slate-500);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
